import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ProcessStatus } from '../../../../models/process-status';
import { ProcessStatusFacade } from '../process-status.facade';
import { environment } from '../../../../../../environments/environment';
import { State } from '../../../../models/status';

@Component({
  selector: 'process-status',
  templateUrl: './process-status.component.html',
  styleUrls: ['./process-status.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProcessStatusComponent implements OnInit, OnDestroy {

  temporalServer: string;
  loading = true;

  allProcesses: ProcessStatus[] = [];
  filteredProcesses: ProcessStatus[] = [];

  selectedFilter = 'all';

  private destroy$ = new Subject<void>();
  private readonly POLL_INTERVAL_MS = 10_000;

  constructor(private facade: ProcessStatusFacade) {
    this.temporalServer = environment.temporalServer;
  }

  ngOnInit(): void {
    // Poll the job list every POLL_INTERVAL_MS; initial fetch fires immediately (delay 0)
    timer(0, this.POLL_INTERVAL_MS)
      .pipe(
        switchMap(() => this.facade.getProcessStatuses$()),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (processes) => {
          this.loading = false;
          this.allProcesses = processes ?? [];
          this.applyFilter();
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFilterChange(): void {
    this.applyFilter();
  }

  setFilter(value: string): void {
    this.selectedFilter = value;
    this.applyFilter();
  }

  openDetailedQueue(): void {
    window.open(this.temporalServer, '_blank');
  }

  trackById(_index: number, process: ProcessStatus): string {
    return process.workflowId;
  }

  private applyFilter(): void {
    switch (this.selectedFilter) {
      case 'running':
        this.filteredProcesses = this.allProcesses.filter(
          p => p.state === State.RUNNING || p.state === State.SUBMITTED
        );
        break;
      case 'done':
        this.filteredProcesses = this.allProcesses.filter(
          p => p.state === State.COMPLETE
        );
        break;
      case 'failed':
        this.filteredProcesses = this.allProcesses.filter(
          p => p.state === State.ERROR || p.state === State.CANCELLED
        );
        break;
      default:
        this.filteredProcesses = [...this.allProcesses];
    }
  }
}
